import React from 'react';
import { ErrorBoundary } from 'src/commons/components/ErrorBoundary';
import { RootState } from 'src/app/store';
import { connect } from 'react-redux';
import {
  selectSalesAssistantLoading,
  selectUserInfoFromHeader,
  UserInfo,
} from '../../store/slice';
import { canShowSalesAssistant } from './salesAssistantUtils';
import { getTaktAttributes } from 'src/commons/utils/logWithTakt';
import { chromeComponents } from 'src/constants';
import { sparkle } from '@amzn/storm-ui-icons';
import UtilityButton from 'src/features/header/components/UtilityMenu/UtilityButton';

// TODO: add label translations
const salesAssistantAriaLabel = 'Sales Assistant Button';
const takt_id = 'sales-assistant-atc';

interface SalesAssistantButtonProps {
  salesAssistantLoaded: boolean;
  userInfo: UserInfo;
}

const SalesAssistantButton: React.VFC<SalesAssistantButtonProps> = (props) => {
  const userEmail = props.userInfo?.customerInfo?.primaryEmail || '';

  if (!props.salesAssistantLoaded || !canShowSalesAssistant(userEmail)) {
    return null;
  }

  const maximizeSalesAssistant = () => {
    window.dispatchEvent(new CustomEvent('salesAssistantMaximize'));
  };

  return (
    <ErrorBoundary name="sales-assistant-button">
      <UtilityButton
        icon={sparkle}
        label={salesAssistantAriaLabel}
        className="sales-assistant-drawer-button"
        id={takt_id}
        onClick={maximizeSalesAssistant}
        {...getTaktAttributes(takt_id, chromeComponents.HEADER)}
      />
    </ErrorBoundary>
  );
};

const SalesAssistantButtonConnector = connect((state: RootState) => {
  return {
    salesAssistantLoaded: selectSalesAssistantLoading(state),
    userInfo: selectUserInfoFromHeader(state),
  };
});

export const ConnectedSalesAssistantButton =
  SalesAssistantButtonConnector(SalesAssistantButton);
